/**
 * This module tracks the user throughout the site, keeping the last
 * visited shop page in local storage so "Continue Shopping" links
 * can point to that page. We also export a click handler which
 * intercepts the link click event and uses history.go(-1) when
 * possible so product options are preserved.
 *
 * `init` should only run once for each page load.
 */

const lastPageKey = 'shopLastPage'
const nonShopPageCountKey = 'shopNonShopPageCount'

export function init() {
  const path = window.location.pathname + window.location.search
  if (isShopUrl(path)) {
    sessionStorage.setItem(lastPageKey, path)
    // reset non shop page count
    sessionStorage.setItem(nonShopPageCountKey, '0')
  } else {
    // increment non shop page count
    sessionStorage.setItem(nonShopPageCountKey, `${getNonShopPageCount() + 1}`)
  }
}

function isShopUrl(path) {
  return !!path.match(/^\/shop[/?$]/) && path !== '/shop/thank-you'
}

function getNonShopPageCount() {
  return parseInt(sessionStorage.getItem(nonShopPageCountKey) || '0', 10) || 0
}

export function getContinueShoppingUrl() {
  return sessionStorage.getItem(lastPageKey) || '/shop'
}

export function continueShoppingClickHandler(event) {
  if (getNonShopPageCount() === 1 && !(event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)) {
    event.preventDefault()
    window.history.go(-1)
  }
}
